
import './App.css';
import ValentinesProposal from './components/ValentinesPage';

function App() {
  return <ValentinesProposal />;
}

export default App;
